import React from 'react';

function NotFound(props) {
    return (
        <div><h1>page non trouvé</h1></div>
    );
}

export default NotFound;